import { FC } from 'react';
import { Grid, HStack } from '@chakra-ui/react';
import { Feature } from '@shinetools/pricing-plan-library';

import { useCurrentPricingPlan } from 'common/hooks/useCurrentPricingPlan';
import Text from 'components/_core/Text';
import LogoUpload from 'components/LogoUpload';
import UpgradablePlanBadge from 'components/UpgradablePlanBadge';

import locales from './locales';

interface LogoUploadInputProps {
  logoUrl: string | null;
}

const LogoUploadInput: FC<LogoUploadInputProps> = ({ logoUrl }) => {
  const { isFeatureAvailable } = useCurrentPricingPlan();

  return (
    <Grid rowGap="space-8">
      <HStack spacing="space-8">
        <Text size="sm" variant="light">
          {locales.formatString(locales.companyLogo)}
        </Text>

        {!isFeatureAvailable(Feature.PersonalizedLogo) ? (
          <UpgradablePlanBadge feature={Feature.PersonalizedLogo} size="sm" />
        ) : null}
      </HStack>

      <LogoUpload logoUrl={logoUrl} />
    </Grid>
  );
};

export default LogoUploadInput;
